import { Button } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface PlanDetailsSideActionsProps {
  loading?: boolean
  onClickChangePlan: () => void
}
export const PlanDetailsSideActionsComponent = ({
  loading,
  onClickChangePlan,
}: PlanDetailsSideActionsProps): ReactElement | null => {
  const { t } = useTranslation()

  return (
    <Button loading={loading} onClick={onClickChangePlan}>
      {t('organization_subscription.choose_plan')}
    </Button>
  )
}
